// src/components/PublicRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = ({ children }) => {
  const { isLoggedIn, authChecked } = useAuth();

  // ⏳ auth check শেষ না হওয়া পর্যন্ত কিছুই করো না
  if (!authChecked) return null;

  if (isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;